module.exports = __webpack_public_path__ + "static/MainPage@0.25x-4ea0d3dca65eb02e92aea57df637faa9.jpg";